var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-img-box",style:({'width': _vm.width, 'height': _vm.height, borderRadius: _vm.borderRadius})},[_c('img',{attrs:{"src":require("@/static/images/no-img.svg"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }